const u = {
    /**
     * 获取单位
     * @param labelName 标签名
     * @returns {string|null}
     */
    getUnit:function (labelName) {
        if (!labelName) return null;
        const startIndex = labelName.indexOf('(');
        const endIndex =labelName.indexOf(')');
        return startIndex!==-1?labelName.substring(startIndex+1,endIndex):'';
    },
    /**
     * 获取标签（去掉单位）
     * @param labelName 标签名
     * @returns {string|null}
     */
    getLabel:function (labelName) {
        if (!labelName) return null;
        const endIndex =labelName.indexOf('(');
        return endIndex!==-1?labelName.substring(0,endIndex):labelName;
    }
};

export default u;

